import { render, staticRenderFns } from "./SupportUsers.vue?vue&type=template&id=64a6d050&scoped=true"
import script from "./SupportUsers.vue?vue&type=script&lang=js"
export * from "./SupportUsers.vue?vue&type=script&lang=js"
import style0 from "./SupportUsers.vue?vue&type=style&index=0&id=64a6d050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6d050",
  null
  
)

export default component.exports